<template>
  <div class="card shadow last-applications-card" v-loading="loading">
    <div class="card-header border-0 ">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">{{ variables.get('lastApplications') }}</h3>
        </div>
      </div>
    </div>
    <div class="table-responsive last-applications-table overflow-hidden">
      <base-table thead-classes="thead-light"
                  :data="tableData" v-if="tableData != null">
        <template slot="columns">
          <th>{{variables.get('applicantName')}}</th>
          <th>{{variables.get('jobApplyDate')}}</th>
          <th class="text-center">{{variables.get('actions')}}</th>
        </template>
        <template slot-scope="{row}">
          <th scope="row">
            <div class="media align-items-center">
              <a href="#" class="avatar rounded-circle mr-3">
                <img 
                :alt="[row.name]" 
                :src="'https://vizyonergenc.com/storage/'+row.avatar"
                class="last-applications-avatar"/>
              </a>
              <div class="media-body">
                <span class="name mb-0 text-sm text-black">{{ row.name }}</span>
              </div>
            </div>
          </th>
          <td>
            <router-link :to="{ path: '/applications/'+row.job_id}"
            class="text-vg-blue job-title">
              <span class=" pr-1">{{ row.title }}</span> 
              <i class="fa fa-location-arrow"></i>
            </router-link>
            <br/>
            <p class="text-black job-date">{{ row.created_at | fixDate }}</p>
            <br/>
          </td>
          <td class="actions-td d-flex flex-column align-items-center justify-content-center">
            <base-button 
            data-toggle="tooltip" data-placement="bottom" :title="variables.get('viewApplication')"
            class="btn btn-sm font-weight-normal bg-vg-green border-0 custom-expandable-button m-1" 
            @click="changeStatus(row)">
              <i class="fa fa-address-card" aria-hidden="true"></i> 
              {{variables.get('viewApplication')}}
            </base-button>

            <router-link :to="{ path: '/applications/'+row.job_id}"
            data-toggle="tooltip" data-placement="bottom" :title="variables.get('viewJob')"
            class="bg-vg-blue text-white custom-expandable-button btn btn-sm">
              <i class="fa fa-location-arrow pt-1"></i>
              <span class="font-weight-normal p-0 m-0">
                {{variables.get('viewAllApplications')}}
              </span>
            </router-link>
          </td>

        </template>
      </base-table>
      <template v-else>
        <p class="text-center text-muted">{{variables.get('notReceiveApplication')}}</p>
      </template>
    </div>

  </div>
</template>
<script>
import {variables} from "@/langs/tr";
import * as axios from "axios";

export default {
  name: 'last-applications-table',
  data() {
    return {
      loading: false,
      variables,
      tableData: []
    }
  },
  created() {
    this.getLastApplications();
  },
  methods: {
    async getLastApplications() {
      this.loading = true,
          await axios.get('company/last-applications').then(response => {
            this.tableData = response.data;
            this.loading = false;
          })
    },
    changeStatus(application) {
      application.status = 1;
      this.$router.push({path: `application-detail/${application.application_id}`})
    },
  },
  filters: {
    fixDate: function (date) {
      if (!date) {
        return '';
      }
      let items = date.split(' ')[0].split('-');
      return items[2] + '.' + items[1] + '.' + items[0];
    },
    listLength: function (list, key, value) {
      return list.filter(function (job) {
        if (job[key] == value) {
          return true;
        }

        return false;
      }).length;
    }
  }
}
</script>
<style scoped>
  @import "../../assets/css/custom.css";

</style>
